import $ from 'jquery';
import 'magnific-popup';

const $popups = $('.js-popup');
const $iframePopups = $('.js-iframe-popup');

if ($popups.length) {
    $popups.magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
    });
}

if ($iframePopups.length) {
    $iframePopups.magnificPopup({
        type: 'iframe',
        iframe: {
            patterns: {
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1',
                },
            },
        },
        callbacks: {
            open: () => {
                if ('vimeoInit' in window) {
                    window.vimeoInit();
                }
                if ('ytTracker' in window) {
                    window.ytTracker.init();
                }
            },
        },
    });
}




// WEBPACK FOOTER //
// ./app/scripts/components/popups.js